import { makeStyles, Theme, createStyles } from "@material-ui/core/styles";
import { getThemeType } from "utils/createTheme";

export default makeStyles((theme: Theme) =>
  createStyles({
    root: {
      display: "flex",
      maxWidth: 800,
      marginLeft: "auto",
      marginRight: "auto",
      flexDirection: "column",
      padding: theme.spacing(4, 2),
    },
    title: {
      fontFamily: "OpenSans",
      fontSize: 40,
      marginBottom: theme.spacing(4),
      color:
        getThemeType(theme.palette.background.default) === "dark"
          ? "#FFF"
          : theme.palette.text.primary,
    },
    center: {
      height: "50vh",
      width: "100%",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
    },
    centerDirection: {
      flexDirection: "column",
    },
    centerMessage: {
      marginBottom: theme.spacing(4),
    },
  })
);
